export default __webpack_public_path__ + "static/media/asurion-loader.853f38cc.gif";